"use strict";

var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["className", "children", "ratio", "style"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var CUSTOM_PROPERTY_NAME = '--aspect-ratio';
var DEFAULT_CLASS_NAME = 'react-aspect-ratio-placeholder';

var AspectRatio = /*#__PURE__*/function (_react$Component) {
  _inherits(AspectRatio, _react$Component);

  var _super = _createSuper(AspectRatio);

  function AspectRatio() {
    var _this;

    _classCallCheck(this, AspectRatio);

    _this = _super.apply(this, arguments);
    _this.node = null;

    _this.setNode = function (node) {
      _this.node = node;
    };

    return _this;
  }

  _createClass(AspectRatio, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.node) {
        var node = this.node; // BC for older version of React https://github.com/facebook/react/issues/6411
        // check if React support custom property AFTER

        var customPropertyValue = node.style.getPropertyValue(CUSTOM_PROPERTY_NAME);

        if (!customPropertyValue) {
          node.style.setProperty(CUSTOM_PROPERTY_NAME, "(" + this.props.ratio + ")");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          ratio = _this$props.ratio,
          style = _this$props.style,
          restProps = _objectWithoutPropertiesLoose(_this$props, _excluded); // eslint-disable-line no-unused-vars


      var newStyle = _extends({}, style, _defineProperty({}, CUSTOM_PROPERTY_NAME, "(" + ratio + ")"));

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _extends({
        className: className,
        ref: this.setNode,
        style: newStyle
      }, restProps, {
        children: children
      }));
    }
  }]);

  return AspectRatio;
}(_react.Component);

AspectRatio.defaultProps = {
  className: DEFAULT_CLASS_NAME,
  ratio: 1
};
var _default = AspectRatio;
exports.default = _default;